<template>
  <b-tooltip
    :label="$t('btnlabel')"
    position="is-left"
    size="is-medium"
    style="position:fixed;bottom:2rem;right:2rem;z-index:99"
  >
    <b-button
      id="BtnDemo"
      type="is-primary animated-bg"
      size="is-large"
      style="border: 3px solid;"
      rounded
      @click="showModalDemoForm"
      icon-right="paper-plane"
    />
  </b-tooltip>
</template>
<script>
import DemoForm from "./DemoForm.vue";
export default {
  name: "BtnDemo",
  data() {
    return {
      title: "BtnDemo",
    };
  },
  methods: {
    showModalDemoForm() {
      this.$buefy.modal.open({
        parent: this,
        component: DemoForm,
        hasModalCard: true,
        trapFocus: true,
        fullSscreen: true,
      });
    },
  },
};
</script>
<i18n>
{
  "es": {
    "btnlabel":"Solicita gratis tu DEMO"
  },
  "en": {
    "btnlabel":"Request your free DEMO"
  },
  "pt": {
    "btnlabel":"Solicite sua DEMO gratuita"
  }
}
</i18n>
